import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfidentialStateService {
  private isConfidentialSubject = new BehaviorSubject<boolean>(false);
  public isConfidential$: Observable<boolean> = this.isConfidentialSubject.asObservable();

  constructor() { }

  setConfidentialState(isConfidential: boolean): void {
    console.log('ConfidentialStateService: Setting state to:', isConfidential);
    console.log('ConfidentialStateService: Current observers count:', this.isConfidentialSubject.observers.length);
    this.isConfidentialSubject.next(isConfidential);
    console.log('ConfidentialStateService: State emitted');
  }

  getCurrentState(): boolean {
    return this.isConfidentialSubject.value;
  }
}